import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import NftDataContainer from "../../components/Nft/NftConiatner";
import axios from "axios";

const CloseButton = styled.button`
  width: 10%;
  position: absolute !important;
  font-size: 1rem;
  background: #393939;
  color: #fff;
  font-weight: 500;
  font-family: Poppins;
  border-radius: 2.5rem;
  padding: 0.7rem 1rem;
  right: 15%;
  cursor: pointer;
  margin-right: -1px;
  @media (max-width: 768px) {
    width: 40%;
  }
`;
const NftViewContainer = styled.div`
  display: flex;
  position: relative;
  background: #f7f7f7;
  flex-direction: column;
  width: 80%;
  margin: auto;
  padding: 3rem;
  border-radius: 1rem;
  margin-top: 7rem;
  min-height: 50vh;
`;
const Heading = styled.h1`
  color: #ffffff;
  text-align: center;
  font-family: Poppins;
  font-size: 22px;
`;
const Profile = (props) => {
  let navigate = useNavigate();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [NftData, setNftData] = useState();
  const loadData = async (url) => {
    try {
      const response = await axios.get(url);
      await setNftData(response.data.data);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!NftData) {
      setLoading(true);
      const api_url = `${process.env.REACT_APP_API_URL}/v1/score/each/${id}`;
      loadData(api_url);
    }
  }, []);
  const goBack = () => {
    navigate("/");
  };

  return (
    <>
      <NftViewContainer>
        {loading && <Heading>Loading Data, Please Wait..</Heading>}
        <CloseButton onClick={goBack}>Go Back</CloseButton>
        {NftData && <NftDataContainer nftData={NftData} />}
      </NftViewContainer>
    </>
  );
};

export default Profile;
